// #endregion
// #region 自注册分析
/**
 * 产品名称 -- 产品ID
 */
export var E_PRODUCT_IDS;
(function (E_PRODUCT_IDS) {
    /**
     * 数据库
     */
    E_PRODUCT_IDS["Analytics"] = "pro";
    E_PRODUCT_IDS["Discovery"] = "a2f4c064c228430a84f6087b5f870487";
    E_PRODUCT_IDS["Bio"] = "563398857b284d14a48575e06990b9e4";
    E_PRODUCT_IDS["Chemical"] = "chemical";
    E_PRODUCT_IDS["Synapse"] = "e5ce470917314759bb2a3184b6e62ca8";
    E_PRODUCT_IDS["Insights"] = "report";
    E_PRODUCT_IDS["Workspace"] = "f207ca60ec064edbbcbc26997985400a";
    /**
     * IpManagement
     */
    E_PRODUCT_IDS["Innosnap"] = "innosnap_product";
    E_PRODUCT_IDS["Course2b"] = "623ddd4fb7f549a7bcdf49b828a9f2ac";
    E_PRODUCT_IDS["Synapse_CN"] = "895f1015a21741bb97019a928c2c578b";
    E_PRODUCT_IDS["TFFI"] = "974ff55f8941429fa7d7f81bd1a42023";
    E_PRODUCT_IDS["Academy"] = "fa02dbb62b9248adb83135957c22ae44";
    E_PRODUCT_IDS["Eureka"] = "bae91377ed7b45209cd48e076392cbbb";
    E_PRODUCT_IDS["OpenAPI"] = "ba56dbe5eb61461dba5a47234700cc86";
})(E_PRODUCT_IDS || (E_PRODUCT_IDS = {}));
export const productNameKey = {
    /**
     * $t("products.analytics")
     */
    [E_PRODUCT_IDS.Analytics]: 'products.analytics',
    /**
     * $t("products.discovery")
     */
    [E_PRODUCT_IDS.Discovery]: 'products.discovery',
    /**
     * $t("products.lifescience")
     */
    [E_PRODUCT_IDS.Bio]: 'products.lifescience',
    /**
     * $t("products.chemical")
     */
    [E_PRODUCT_IDS.Chemical]: 'products.chemical',
    /**
     * $t("products.synapse")
     */
    [E_PRODUCT_IDS.Synapse]: 'products.synapse',
    /**
     * $t("products.insights")
     */
    [E_PRODUCT_IDS.Insights]: 'products.insights',
    /**
     * $t('products.workspace')
     */
    [E_PRODUCT_IDS.Workspace]: 'products.workspace',
    /**
     * $t("products.inno")
     */
    [E_PRODUCT_IDS.Innosnap]: 'products.inno',
    /**
     * $t("products.academy")
     */
    [E_PRODUCT_IDS.Academy]: 'products.academy',
    /**
     * $t('products.eureka')
     */
    [E_PRODUCT_IDS.Eureka]: 'products.eureka',
    /**
     * $t('products.synapse')
     */
    [E_PRODUCT_IDS.Synapse_CN]: 'products.synapse',
    /**
     * $t('products.tffi')
     */
    [E_PRODUCT_IDS.TFFI]: 'products.tffi',
    /**
     * $t('products.openapi')
     */
    [E_PRODUCT_IDS.OpenAPI]: 'products.openapi',
};
export var E_ACTIVITY_STATUS;
(function (E_ACTIVITY_STATUS) {
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_STATUS.NOT_EFFECTIVE')
     */
    E_ACTIVITY_STATUS["NOT_EFFECTIVE"] = "NOT_EFFECTIVE";
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_STATUS.EFFECTIVE')
     */
    E_ACTIVITY_STATUS["EFFECTIVE"] = "EFFECTIVE";
    /**
     *  $t('backoffice.operationPromotionLink.E_ACTIVITY_STATUS.EXPIRED')
     */
    E_ACTIVITY_STATUS["EXPIRED"] = "EXPIRED";
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_STATUS.SUSPEND')
     */
    E_ACTIVITY_STATUS["SUSPEND"] = "SUSPEND";
})(E_ACTIVITY_STATUS || (E_ACTIVITY_STATUS = {}));
// 必填选项包含：必填、选填、不显示，
export var E_ACTIVITY_OBJECT_REQUIRED;
(function (E_ACTIVITY_OBJECT_REQUIRED) {
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_OBJECT.REQUIRED')
     */
    E_ACTIVITY_OBJECT_REQUIRED["REQUIRED"] = "REQUIRED";
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_OBJECT.DISPLAY')
     */
    E_ACTIVITY_OBJECT_REQUIRED["DISPLAY"] = "DISPLAY";
    /**
     * $t('backoffice.operationPromotionLink.E_ACTIVITY_OBJECT.HIDDEN')
     */
    E_ACTIVITY_OBJECT_REQUIRED["HIDDEN"] = "HIDDEN";
})(E_ACTIVITY_OBJECT_REQUIRED || (E_ACTIVITY_OBJECT_REQUIRED = {}));
/**
 * 活动对象（新，老）
 */
export var E_ACTIVITY_OBJECT;
(function (E_ACTIVITY_OBJECT) {
    E_ACTIVITY_OBJECT["new"] = "new";
    E_ACTIVITY_OBJECT["all"] = "all";
})(E_ACTIVITY_OBJECT || (E_ACTIVITY_OBJECT = {}));
